import { get, set } from 'lodash';

import { FIELD_PATHS, NO_RELATIONSHIP } from '@funnels/constants';
import { StoreApplicant } from '@funnels/types';

function fixRelationshipDetails(applicants: StoreApplicant[], applicantIndex: number) {
  const applicantClientId = get({ applicants }, FIELD_PATHS.APPLICANT_CLIENT_ID(applicantIndex));
  const maritalStatus = get({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_STATUS(applicantIndex));
  const partnerId = get({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_DETAILS_APPLICANT_ID(applicantIndex));
  const isNotInARelationship = NO_RELATIONSHIP.includes(maritalStatus);

  if (!applicantClientId) {
    return;
  }

  if (isNotInARelationship && !!get({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_DETAILS(applicantIndex))) {
    set({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_DETAILS(applicantIndex), undefined);
  }

  applicants.forEach((__: StoreApplicant, index: number) => {
    if (index === applicantIndex) {
      return;
    }

    const partnerId = get({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_DETAILS_APPLICANT_ID(index), 'NOT_MARRIED');

    // clean previous partner
    if (partnerId === applicantClientId) {
      set({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_DETAILS(index), undefined);
      set({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_STATUS(index), undefined);
    }
  });

  if (partnerId) {
    const partnerIndex = applicants.findIndex((applicant: StoreApplicant) => applicant.clientId === partnerId);

    set({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_DETAILS_APPLICANT_ID(partnerIndex), applicantClientId);
    set({ applicants }, FIELD_PATHS.APPLICANT_MARITAL_STATUS(partnerIndex), maritalStatus);
  }
}

export default fixRelationshipDetails;
